import React from 'react'

interface JourneyStep {
  number: string
  title: string
  description: string
}

interface JourneySectionProps {
  title: string
  steps: JourneyStep[]
  backgroundColor?: 'white' | 'gray' | 'gradient'
  className?: string
}

const JourneySection: React.FC<JourneySectionProps> = ({
  title,
  steps,
  backgroundColor = 'white',
  className = ''
}) => {
  const getBgClasses = () => {
    switch (backgroundColor) {
      case 'gray':
        return 'bg-gray-50'
      case 'gradient':
        return 'bg-gradient-to-br from-gray-50 to-gray-100'
      default:
        return 'bg-white'
    }
  }

  return (
    <section className={`section-padding ${getBgClasses()} ${className}`}>
      <div className="container-custom">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-dark-plum mb-16 text-center">
            {title}
          </h2>

          <div className="space-y-12">
            {steps.map((step, index) => (
              <div key={index} className="flex items-start space-x-6">
                {/* Step Number */}
                <div className="flex-shrink-0 w-16 h-16 bg-primary-green rounded-full flex items-center justify-center">
                  <span className="text-2xl font-bold text-white">
                    {step.number}
                  </span>
                </div>

                {/* Step Content */}
                <div className="flex-1 pt-2">
                  <h3 className="text-xl md:text-2xl font-semibold text-dark-plum mb-3">
                    {step.title}
                  </h3>
                  <p className="text-lg text-gray-700 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default JourneySection